(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "f1586c5c064bd8d780bb636357f3627066c5fdbc"
};